import { CircularProgress, Grid, Typography } from '@mui/material';
import type { UseFormReturn } from 'react-hook-form';
import { _ } from '/@/locale';
import type { CPType, CropProtectionForm } from '/@/types/crop-protection';

const LoadCPCreation = ({ form }: { form: UseFormReturn<CropProtectionForm> }) => {
    const textMapping: Record<CPType, string> = {
        weeds: _('Creando recomendaciones para un control eficiente de malezas'),
        plagues: _('Creando recomendaciones para un control eficiente de plagas'),
        diseases: _('Creando recomendaciones para un control eficiente de enfermedades'),
        seed_treatment: _('Creando recomendaciones para el tratamiento de semillas'),
    };

    return (
        <Grid
            container
            direction='column'
            alignItems='center'
            justifyContent={'center'}
            sx={{ height: 'inherit', maxWidth: 500, m: 'auto' }}
        >
            <Grid item>
                <Typography color='primary' variant='h3' sx={{ textAlign: 'center', mt: 1 }}>
                    {textMapping[form.getValues().type as CPType]}
                </Typography>
            </Grid>
            <Grid item sx={{ my: 5 }}>
                <CircularProgress size={75} />
            </Grid>
            <Grid item>
                <Typography color='primary' variant='body2' sx={{ textAlign: 'center', mt: 1 }}>
                    {_(
                        'Nuestras recomendaciones se basan en tus respuestas y en los estudios y tendencias regionales de nuestra base de datos.'
                    )}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default LoadCPCreation;
